import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, inject } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { ICreateBase } from '@fi-shared/models/models';
import { SharedActionsBaseService } from '@fi-shared/fi-shared-services/shared-actions-base.service';
import { FiDateFormatOptions } from '@fi-app/shared/utils';

@Component({
    selector: 'fi-wrapper-table-created-by-cell',
    templateUrl: './fi-wrapper-table-created-by-cell.component.html',
    styleUrls: ['./fi-wrapper-table-created-by-cell.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-wrapper-table-created-by-cell' },
    standalone: false,
})
export class FiWrapperTableCreatedByCellComponent extends FiWrapperTableCellBase<ICreateBase> {
    public readonly isDateShown = input<boolean>(false);
    public readonly fiDateFormatRegistry = input<Intl.DateTimeFormatOptions>(FiDateFormatOptions);

    private sharedActionsService = inject(SharedActionsBaseService);

    protected openUserViewDialog($event: MouseEvent, itemChangedByUserId: number): void {
        $event.stopPropagation();
        this.sharedActionsService.openUserViewPopup(itemChangedByUserId);
    }
}
